import axios from '@/service/interceptor';

function getCoinConvertAmount(params) {
    const pm = new Promise((resolve) => {
        axios.post('https://payment.bytetrade.com/getCoinConvertAmount', params).then((res) => {
            resolve(res);
        });
    });
    return pm;
}
function getAmountList(params) {
    const pm = new Promise((resolve) => {
        axios.post('https://payment.bytetrade.com/getAmountList', params).then((res) => {
            resolve(res);
        });
    });
    return pm;
}

function createTransaction(params) {
    const pm = new Promise((resolve, reject) => {
        axios.post('https://payment.bytetrade.com/createTransaction', params).then((res) => {
            resolve(res);
        }).catch(function(err) {
            reject(err);
        });
    });
    return pm;
}


export default {
    getCoinConvertAmount,
    createTransaction,
    getAmountList,
};



// WEBPACK FOOTER //
// ./src/utils/fiat.js